import { Icon } from '@iconify/react';
import type { Ref } from 'react';
import { Card } from '@/components/shadcn/card';
import type { PickleballStandingItem } from '@/services/pickleballService';
import PickleballStandingsTable from './PickleballStandingsTable';

interface PickleballExportCanvasProps {
  eventName: string;
  standings: PickleballStandingItem[];
  canvasRef: Ref<HTMLDivElement>;
}

export default function PickleballExportCanvas({
  eventName,
  standings,
  canvasRef,
}: PickleballExportCanvasProps) {
  return (
    <div className="pointer-events-none fixed left-[-9999px] top-0 w-[390px] bg-[#F4F6F8] p-4">
      <div ref={canvasRef} className="space-y-4 bg-[#F4F6F8] p-4">
        <Card className="flex flex-row items-center gap-2 rounded-2xl border-0 bg-white p-3 shadow-[inset_0_0_0_1px_#E0E6ED]">
          <Icon icon="mdi:tennis" className="h-5 w-5 text-[#FC480D]" />
          <p className="text-base font-extrabold text-[#0E1726]">{eventName}</p>
        </Card>
        <div>
          <p className="mb-2 text-sm font-extrabold text-[#0E1726]">Klasemen Pickleball</p>
          <PickleballStandingsTable standings={standings} />
        </div>
      </div>
    </div>
  );
}
